import { render, staticRenderFns } from "./TransportList.vue?vue&type=template&id=ef71a406&scoped=true&"
import script from "./TransportList.vue?vue&type=script&lang=js&"
export * from "./TransportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef71a406",
  null
  
)

export default component.exports